module.exports = __webpack_public_path__ + "img/UNKNOWN_COMPETITIVE_SITE.3670ceb5.png";